import { opaque, opaque_, summonFor } from "./Batteries/summoner/index.mjs"; //
// Summoner
//

export { summonFor as makeFor } from "./Batteries/summoner/index.mjs"; //
// URIS
//

export { FastCheckURI } from "./FastCheck/base/index.mjs";
export { GuardURI } from "./Guard/base/index.mjs";
export { DecoderURI } from "./Decoder/base/index.mjs";
export { EncoderURI } from "./Encoder/base/index.mjs";
export { EqURI } from "./Equal/base/index.mjs";
export { ShowURI } from "./Show/base/index.mjs";
export { StrictURI } from "./Strict/base/index.mjs";
export { TypeHashURI as HashURI } from "./TypeHash/base/index.mjs";
export { ReorderURI } from "./Reorder/base/index.mjs";
export { opaque, opaque_ }; //
// Defaults
//

export const {
  make,
  makeADT,
  makeProgram
} = /*#__PURE__*/(() => summonFor({}))();
//# sourceMappingURL=index.mjs.map